import { Moment } from "moment";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import Utils from "../utils";
import { DataModel, SyncDataModel, SyncModel } from "./syncModel";
import { orderTypes, paymentMethods, paymentPartners, orderStatus } from "./webshop.model";

export class OrderHistoryDetailViewModel {
  /** Order ID/Number */
  public id: number;
  /**HypCusNr/Order-Location */
  public location: number;
  /** Location label DE */
  public loc_label_de: string;
  /** Location label EN */
  public loc_label_en: string;
  /** Street of location */
  public loc_street: string;
  /**Zip-Code of location */
  public loc_zip: string;
  /** City of location */
  public loc_city: string;
  /**Order date-time */
  public order_at: string;
  /**Order type/service type */
  public order_type: number;
  /**Payment method */
  public payment_method: paymentMethods;
  /**Order completed */
  public process_completed_pos_at_ymd: number;
  /** NoCoo Code */
  public nocoo_code: string;
  /** NoCoo PIN */
  public nocoo_pin: string;
  /** Order items */
  public items: OrderHistoryItemDataModel[];
  /** Group name */
  public groupName?: string;
  /** Currency */
  public currency: string;
  /** Delivery fee */
  public delivery_fee: number;
  /** Tip */
  public tip: number;
  /** Main payment amount */
  public payment_amount: number;

  /** Label DE/EN */
  public get label(): string {
    return InternationalisationService.locale === "de" || Utils.IsNullOrEmpty(this.loc_label_en) ? this.loc_label_de : this.loc_label_en;
  }

  /** Order state boolean */
  public get process_completed(): boolean {
    return this.process_completed_pos_at_ymd != -1;
  }

  /**Tip: boolean */
  public get isTip(): boolean {
    return this.tip > 0.0;
  }

  /** Delivery fee boolean */
  public get isDeliveryFee(): boolean {
    return this.delivery_fee > 0.0;
  }

  /** check if there is a NoCoo-code */
  public get isNoCoo(): boolean {
    if (this.nocoo_code != "") {
      return true;
    } else {
      return false;
    }
  }

  /* Hierbei handelt es sich um die Mitgliedsnamen der Gruppenbestellung! */
  public group_member_names?: Record<number, string>
}

export class OrderDetailLocationViewModel {
  /** Location ID/Number */
  public locationId: number;
  /** Location Image */
  public location_image: string;
}

export class OrderHistoryViewModel {
  /** Order ID/Number */
  public id: number;
  /**HypCusNr/Order-Location */
  public location: number;
  /** Order ymd */
  public order_at_ymd: number;
  /** Order Moment */
  public order_at: Moment;
  /** Order type/service type */
  public order_type: any;
  /** Main Payment amount */
  public payment_amount: number;
  /** Currency */
  public currency: string;
  /** Location label DE */
  public loc_label_de: string;
  /**Location label EN */
  public loc_label_en: string;
}

// Requests
/** Anfrage für neue/aktuelle Bestellhistorie */
export class OrderHistorySyncModel extends SyncModel {
}

// TODO zu beachten sind Bestellungen, welche Status!=0 haben und nicht Deleted sind
// TODO Wenn process_completed_pos_at_ymd != -1 ist, bedeutet es Bestellung ist Abgeschloßen, andernfalls in Bearbeitung

// Responses
/** Bestellung aus der Bestellhistorie */
export class OrderHistoryDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  /** Bestellungs ID/Nummer */
  public id: number;
  /** HypCusNr, des Standort der Bestellung */
  public location: number;
  /** Standort - Bezeichnung DE */
  public loc_label_de: string;
  /** Standort - Bezeichnung EN */
  public loc_label_en: string;
  /** Standort - Strasse */
  public loc_street: string;
  /** Standort - PLZ */
  public loc_zip: string;
  /** Standort - Stadt */
  public loc_city: string;
  /** siehe order_at */
  public order_at_ymd: number;
  /** siehe order_at */
  public order_at_hms: number;
  /** Bestellungsdatum */
  public get order_at(): Moment {
    return Utils.GetMomentFromInt(this.order_at_ymd, this.order_at_hms);
  }
  /** Bestellungstyp */
  public order_type: orderTypes;
  /** Interner Status der Bestellung */
  public status: orderStatus;
  /** siehe wanted_handover_at */
  public wanted_handover_at_ymd: number;
  /** siehe wanted_handover_at */
  public wanted_handover_at_hms: number;
  /** Gewünschte Liefer-/Abhol-Zeitpunkt */
  public get wanted_handover_at(): Moment {
    return Utils.GetMomentFromInt(this.wanted_handover_at_ymd, this.wanted_handover_at_hms);
  }
  /** siehe pickedupfrom_pos_at */
  public pickedupfrom_pos_at_ymd: number;
  /** siehe pickedupfrom_pos_at */
  public pickedupfrom_pos_at_hms: number;
  /** Bestellung wurde vom POS abgerufen */
  public get pickedupfrom_pos_at(): Moment {
    return Utils.GetMomentFromInt(this.pickedupfrom_pos_at_ymd, this.pickedupfrom_pos_at_hms);
  }
  /** siehe in_processing_pos_at */
  public in_processing_pos_at_ymd: number;
  /** siehe in_processing_pos_at */
  public in_processing_pos_at_hms: number;
  /** Bestellung befindet sich in Bearbeitung am POS */
  public get in_processing_pos_at(): Moment {
    return Utils.GetMomentFromInt(this.in_processing_pos_at_ymd, this.in_processing_pos_at_hms);
  }
  /** siehe process_completed_pos_at */
  public process_completed_pos_at_ymd: number;
  /** siehe process_completed_pos_at */
  public process_completed_pos_at_hms: number;
  /** Bestellung wurde am POS Abgeschlossen */
  public get process_completed_pos_at(): Moment {
    return Utils.GetMomentFromInt(this.process_completed_pos_at_ymd, this.process_completed_pos_at_hms);
  }
  /** siehe operation_failure_pos_at */
  public operation_failure_pos_at_ymd: number;
  /** siehe operation_failure_pos_at */
  public operation_failure_pos_at_hms: number;
  /** Verarbeitungs Fehler am POS */
  public get operation_failure_pos_at(): Moment {
    return Utils.GetMomentFromInt(this.operation_failure_pos_at_ymd, this.operation_failure_pos_at_hms);
  }
  /** Währungssymbol */
  public currency: string;
  /** Liefergebühren */
  public delivery_fee: number;
  /** Trinkgeld */
  public tip: number;
  /** Versandkosten */
  public shipping: number;
  /** Brutto Gesamt Preis */
  public price: number;
  /** Gesamt Rabatt */
  public discount_value: number;
  /** Main Zahlungs Betrag */
  public payment_amount: number;
  /** Main Zahlungspartner */
  public payment_partner: paymentPartners;
  /** Main Zahlungsart */
  public payment_method: paymentMethods;
  /** Sub Zahlungs Betrag (ignorieren wenn 0) */
  public partial_payment_amount: number;
  /** Sub Zahlungspartner */
  public partial_payment_partner: paymentPartners;
  /** Sub Zahlungsart */
  public partial_payment_method: paymentMethods;
  /** Tischnummer */
  public table_nr: number;
  /** Platz */
  public place_nr: number;
  /** NoCOO Code (wenn Kunde NoCOO nutzt und es eine zur Bestellung gibt) */
  public nocoo_code: string;
  /** NoCOO Pin */
  public nocoo_pin: string;
  /** Artikel der Bestellung */
  public items: OrderHistoryItemDataModel[];
  /** ist als gelöscht sollte nicht dargestellt werden */
  public deleted: boolean;
  /** siehe changed_at */
  public changed_at_ymd: number;
  /** siehe changed_at */
  public changed_at_hms: number;
  /** Letzte Änderung */
  public get changed_at(): Moment {
    return Utils.GetMomentFromInt(this.changed_at_ymd, this.changed_at_hms);
  }
  public group_name?: string;
  public group_member_names?: Record<number, string>
}

/** Artikel der Bestellhistorie */
export class OrderHistoryItemDataModel {
  /** User ID of the remote group order */
  public member_id?: number;
  /** Position */
  public position: number;
  /** Anzahl (kann z.b. als "3x" dargestellt werden) */
  public count: number;
  /** Bezeichnung */
  public name: string;
  /** Brutto Gesamt Preis */
  public price: number;
  /** USt. Satz */
  public vat: number;
  /** USt. Wert */
  public vat_value: number;
  /** Extras, wenn es welche gibt */
  public extras: OrderHistoryItemExtraDataModel[];
  /** CusRefId, die zum jetzigen Stand nur für das Mapping eines Items zu einem Gruppenmitgliedsnamen genutzt wird */
  public cusRefId?: number;
  //! cusRefId returns null ,even if there are group members. So an item cannot be assigned to the user.
  /** Bonusaction ID, wenn der Artikel als Benefit gebucht wurde */
  public bonusactionId?: number;
  /** Benefit ID, wenn der Artikel als Benefit gebucht wurde */
  public benefitId?: number;
}

/** Extra zum Artikel */
export class OrderHistoryItemExtraDataModel {
  /** Position */
  public position: number;
  /** Anzahl (kann z.b. als "3x" dargestellt werden) */
  public count: number;
  /** Bezeichnung */
  public name: string;
}

/** Synchronisations Datenmodel für die Bestellhistorie */
export class OrderHistorySyncDataModel extends SyncDataModel {
  public orders: OrderHistoryDataModel[];
  public get models(): DataModel[] { return this.orders; }
  public DeserializeType(): void {
    this._DeserializeType(OrderHistoryDataModel);
  }
}
